// /dashboard/:orgSlug/analytics/engagement — dwell-derived readings, reported
// on their own rather than multiplied into a usage rank.
//
// The thinnest of the three axes, and deliberately so: engagement is where the
// retired `confusion_score` lived, and the discipline that replaced it is that
// dwell is shown as its own number and ranks nothing. A panel added here has to
// answer "how deeply", not "how much" — that is the usage axis — and not "how
// do concepts relate", which is coupling.

import { createRoute } from "@tanstack/react-router";
import { shellRoute } from "./_shell";
import { AnalyticsScreen } from "../screens/analytics/AnalyticsScreen";
import {
  DEFAULT_RANGE,
  isRangeDays,
  type RangeDays,
} from "../screens/analytics/RangeChips";

type EngagementSearch = { days: RangeDays; corpus?: string };

export const analyticsEngagementRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: "/dashboard/$orgSlug/analytics/engagement",
  staticData: { title: "Analytics · Engagement" },
  validateSearch: (search: Record<string, unknown>): EngagementSearch => {
    const raw = Number(search.days);
    return {
      days: isRangeDays(raw) ? raw : DEFAULT_RANGE,
      corpus: typeof search.corpus === "string" ? search.corpus : undefined,
    };
  },
  component: AnalyticsEngagementRoute,
});

function AnalyticsEngagementRoute() {
  const { orgSlug } = analyticsEngagementRoute.useParams();
  const search = analyticsEngagementRoute.useSearch();
  const navigate = analyticsEngagementRoute.useNavigate();

  return (
    <AnalyticsScreen
      orgSlug={orgSlug}
      axis="engagement"
      days={search.days}
      corpus={search.corpus}
      onRangeChange={(days) =>
        navigate({ search: (prev: EngagementSearch) => ({ ...prev, days }) })
      }
      onCorpusChange={(corpus) =>
        navigate({ search: (prev: EngagementSearch) => ({ ...prev, corpus }) })
      }
    />
  );
}
